import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const zvuk: MusicService = {
  id: 'zvuk',
  name: 'Zvuk (Звук)',
  shortName: 'Zvuk',
  isSupported: false,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: false,
  isAlbumTransferSupported: true,
  color: {
    primary: '#47e0dc',
    label: '#37D0DC',
    background: '#738688',
  },
  importerID: ImporterID.Zvuk,
  musicAPIID: MusicAPIIntegrationID.Zvuk,
  linkType: 'zvuk',
  assets: {
    logo: { light: 'zvuk-light.svg', dark: 'zvuk-dark.svg' },
    logoPadding: { light: 'zvuk-light-padding.svg', dark: 'zvuk-dark-padding.svg' },
    logoColor: { light: 'zvuk-color-light.svg', dark: 'zvuk-color-dark.svg' },
    logoColorPadding: {
      light: 'zvuk-color-light-padding.svg',
      dark: 'zvuk-color-dark-padding.svg',
    },
    logoOnBackground: 'zvuk-color-dark.svg',
  },
  whatIsDescription: musicServiceMessages.zvukWhatIs,
};
